<template>
  <div :class="classnames">
    <slot />

    <drawer-button :isOpen="isOpen" />
  </div>
</template>

<script>
  import DrawerButton from './DrawerButton'

  import { bem } from '@/mixins/bem.js'

  const namespace = 'drawer-control'

  const modifiers = {
    isOpen: 'is-open'
  }

  export default {
    name: 'DrawerControl',
    components: {
      'drawer-button': DrawerButton
    },
    mixins: [ bem ],
    props: {
      isOpen: {
        type: Boolean
      }
    },
    data: function () {
      return {}
    },
    created: function () {
      this.namespace = namespace
    },
    methods: {
      classnameModifiers: function () {
        const isOpen = this.isOpen && modifiers.isOpen

        return [ isOpen ]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/Drawer/DrawerControl.vue